import { type MouseEvent, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'
import styles from './AdaptiveSheet.module.css'

interface AdaptiveSheetProps {
  onClose: () => void
  children: ReactNode
  /**
   * `auto` — высота по содержимому (max 90vh). Подходит для коротких форм.
   * `fixed` — на мобиле фиксированные 70vh (для статусных экранов с прижатой к низу кнопкой).
   * На десктопе обе схемы рендерятся как центрированный попап.
   */
  height?: 'auto' | 'fixed'
  showClose?: boolean
}

/**
 * Адаптивная модалка-обёртка: на ≤600px — bottom-sheet, на ≥601px — центрированный попап.
 * Управляется через media-query в `AdaptiveSheet.module.css`.
 */
export const AdaptiveSheet = ({
  onClose,
  children,
  height = 'auto',
  showClose = true,
}: AdaptiveSheetProps) => {
  const stop = (e: MouseEvent<HTMLDivElement>) => e.stopPropagation()
  const sheetClass = `${styles.sheet} ${
    height === 'fixed' ? styles.sheetFixedHeight : styles.sheetAuto
  }`

  return createPortal(
    <div className={styles.overlay} onClick={onClose} role="presentation">
      <div className={sheetClass} onClick={stop}>
        {showClose && (
          <button
            type="button"
            className={styles.close}
            onClick={onClose}
            aria-label="Close"
          >
            <X size={24} strokeWidth={2} />
          </button>
        )}
        {children}
      </div>
    </div>,
    document.body
  )
}
